import { generatePath } from 'react-router-dom';

export const joinUrl = (rootUrl, nestedUrl) => {
  return [rootUrl, nestedUrl].map(generatePath).join('/');
};
